import { ThemedButton } from "Components/Themes/components/ThemedButton";
import styled from "styled-components";

export const SearchButton = styled(ThemedButton)`
  flex-shrink: 0;
  margin-left: 12px;
`;

export const Label = styled.label`
  font-family: "Open Sans", sans-serif;
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  margin-bottom: ${({ theme }) => theme.spacing.sm};
  word-wrap: break-word;
`;

export const SearchWrapper = styled.div`
  display: flex;
  flex-direction: column;

  & + * {
    margin-top: 21px;
  }

  & > .hint {
    margin: -8px 0 16px;
  }
`;

export const FlexDiv = styled.div`
  display: flex;
`;
